import { useLocalization } from '@/shared/composables/localization'
import { getTextForDifferentCount } from '@/shared/utils/get-text-for-different-count'

const getFilesText = (count: number) => {
  const { tc } = useLocalization()
  const config = {
    forOne: tc('common.fileP', 0), // ignored by template
    forTwo: tc('common.fileP', 1),
    forFive: tc('common.fileP', 2),
  }

  return getTextForDifferentCount(count, config)
}

export function useMessageFilesPreview () {
  return {
    getFilesText,
  }
}

